import { RegisterUserButton } from "@/components/atoms";
import { css } from "@emotion/react";
import { User } from "@/models";
import { PageTitle } from "@/components/molecules";
import { UsersTable } from "@/components/organisms";
import { MainTemplate } from "@/components/templates";
import { TableColumn } from "react-data-table-component";
import config from "@/libs/config";

type Props = {
  columns: TableColumn<User>[];
};

export const ManageUsersPage = ({ columns }: Props) => {
  // [NOTE]
  // ConnectBoard利用金融は事実上、第四北越銀行のみであるが
  // 抽象化のため、constants.IS_DHBK ではなく、constants.USING_CONNBOARD を使用する
  const canRegisterUser = !config.USING_CONNBOARD;

  return (
    <MainTemplate title={`利用者管理`}>
      <PageTitle mainTitle={`利用者管理`} />
      {canRegisterUser && (
        <div css={button}>
          <RegisterUserButton />
        </div>
      )}
      <UsersTable columns={columns} rowsPerPage={20} />
    </MainTemplate>
  );
};

const button = css({
  display: "flex",
  justifyContent: "end",
});
